module.exports = __webpack_public_path__ + "static/img/bannerindex.2768e5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/bannerindex.jpg
// module id = 8vBI
// module chunks = 9